import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import theme, { ThemeProviderRtl } from "./config/theme";
import { GlobalStyles } from "@mui/material";
import CustomToastContainer from "./components/ToastContainer";
import { AuthProvider } from "./store/auth-cxt";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "react-toastify/dist/ReactToastify.css";
import "./assets/css/index.css";
import "./assets/css/fonts.css";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProviderRtl>
          <GlobalStyles
            styles={{
              body: {
                backgroundColor: theme.palette.background.default,
              },
            }}
          />
          <AuthProvider>
            <CustomToastContainer />
            <App />
          </AuthProvider>
        </ThemeProviderRtl>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
